import api from "../../Environment";

/**
 * Film Festival Phase 3 — public API client.
 * Festival Pass purchase reuses existing /pay-per-view (no new checkout).
 */

function unwrap(response) {
  return response && response.data ? response.data : null;
}

function apiErrorMessage(error, fallback) {
  const body =
    error && error.response && error.response.data
      ? error.response.data
      : null;
  if (body && (body.error_message || body.error)) {
    return body.error_message || body.error;
  }
  return fallback;
}

function authIds() {
  const id = localStorage.getItem("userId");
  const token = localStorage.getItem("accessToken");
  const out = {};
  if (id) out.id = id;
  if (token) out.token = token;
  return out;
}

export async function fetchFilmFestivalList() {
  try {
    const body = unwrap(
      await api.postMethod("film_festival/list", { ...authIds() })
    );
    if (body && body.success && Array.isArray(body.data)) {
      return {
        editions: body.data,
        experience: body.experience || null,
        error: false,
        message: null,
      };
    }
    return {
      editions: [],
      experience: null,
      error: true,
      message:
        (body && (body.error_message || body.error)) ||
        "We couldn’t load Film Festival editions.",
    };
  } catch (e) {
    return {
      editions: [],
      experience: null,
      error: true,
      message: apiErrorMessage(
        e,
        "We couldn’t load Film Festival editions. Please try again."
      ),
    };
  }
}

export async function fetchFilmFestivalEdition(slug) {
  if (!slug) {
    return { edition: null, error: true, message: "Festival slug required." };
  }
  try {
    const body = unwrap(
      await api.postMethod("film_festival/show", { slug, ...authIds() })
    );
    if (body && body.success && body.data) {
      return { edition: body.data, error: false, message: null };
    }
    return {
      edition: null,
      error: true,
      message:
        (body && (body.error_message || body.error)) ||
        "We couldn’t load this festival.",
    };
  } catch (e) {
    const status = e && e.response ? e.response.status : null;
    const message = apiErrorMessage(
      e,
      "We couldn’t load this festival. Please try again."
    );
    return {
      edition: null,
      error: true,
      message: status === 404 ? message || "Festival not found" : message,
    };
  }
}
